import React from 'react';

const Italic = ({ 
  height = '48px', 
  width = '48px', 
  color = '#335262'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>italic</title>
    <g>
      <path d="M11.83332,48l0.332-3.24984l4.83968-0.46426c0.92853-0.06478,1.06079-0.3293,1.19305-1.32531L23.502,5.03942 c0.13226-0.99601,0.06748-1.26053-0.86105-1.32801l-4.63994-0.46426L18.39779,0h17.76888l-0.39948,3.24715l-5.03672,0.53174 c-0.99601,0.13226-1.06349,0.26452-1.19575,1.26053L24.166,42.8958c-0.13226,1.06079-0.13226,1.19305,0.86105,1.32531 l4.90716,0.52905L29.60221,48H11.83332z" fill={color} />
    </g>
  </svg>
);

export default Italic;
